// Custom HAProxy mode for Ace Editor
import ace from 'ace-builds';
import 'ace-builds/src-noconflict/mode-text';

// Create a custom mode for HAProxy configuration syntax
export const defineHAProxyMode = () => {
  try {
    // Check if mode is already defined
    try {
      const haproxyMode = ace.require('ace/mode/haproxy');
      if (haproxyMode) {
        return; // Mode already exists
      }
    } catch (e) {
      // Mode doesn't exist, continue with definition
    }

    // Define the highlighting rules
    (ace as any).define('ace/mode/haproxy_highlight_rules', ['require', 'exports', 'ace/lib/oop', 'ace/mode/text_highlight_rules'], 
    function(require: any, exports: any) {
      const oop = require('ace/lib/oop');
      const TextHighlightRules = require('ace/mode/text_highlight_rules').TextHighlightRules;
      
      // Constructor pattern that Ace expects
      const HAProxyHighlightRules = function(this: any) {
        this.$rules = {
          "start": [
            // Comments
            {
              token: "comment",
              regex: "#.*$"
            },
            // Section headers
            {
              token: "keyword.section",
              regex: "^\\s*(global|defaults|frontend|backend|listen)\\b",
            },
            // Directives
            {
              token: "keyword.directive",
              regex: "^\\s*(bind|mode|option|balance|timeout|maxconn|log|server|use_backend|default_backend|acl|http-request|http-response)\\b",
            },
            // IPs and hostnames
            {
              token: "constant.numeric",
              regex: "\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\b"
            },
            // Placeholders
            {
              token: "string.placeholder",
              regex: "\\{\\{BACKENDS\\}\\}"
            },
            // Strings in quotes
            {
              token: "string",
              regex: '"(?=.)(\\\\.|[^"\\\\])*?"'
            },
            // Numbers
            {
              token: "constant.numeric",
              regex: "\\b\\d+\\b"
            }
          ]
        };
      };
      
      oop.inherits(HAProxyHighlightRules, TextHighlightRules);
      exports.HAProxyHighlightRules = HAProxyHighlightRules;
    });
    
    // Define the mode itself
    (ace as any).define('ace/mode/haproxy', ['require', 'exports', 'ace/lib/oop', 'ace/mode/text', 'ace/mode/haproxy_highlight_rules'], 
    function(require: any, exports: any) {
      const oop = require('ace/lib/oop');
      const TextMode = require('ace/mode/text').Mode;
      const HAProxyHighlightRules = require('ace/mode/haproxy_highlight_rules').HAProxyHighlightRules;
      
      const Mode = function(this: any) {
        this.HighlightRules = HAProxyHighlightRules;
        this.$behaviour = this.$defaultBehaviour;
      };
      
      oop.inherits(Mode, TextMode);
      exports.Mode = Mode;
    });

    console.log('HAProxy mode defined successfully');
  } catch (error) {
    console.error('Error defining HAProxy mode:', error);
  }
};

// Initialize the mode
defineHAProxyMode(); 